import React, { useRef } from "react";
import { Grid, Typography, Button, Card, CardActionArea, CardMedia, makeStyles, Divider } from "@material-ui/core";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";

const useStyles = makeStyles((theme) => ({
  section: {
    marginBottom: theme.spacing(4),
  },
  cardContainer: {
    display: "flex",
    justifyContent: "center",
    overflowX: "auto",
    gap: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    "&::-webkit-scrollbar": {
      height: 8,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#000",
      borderRadius: 4,
    }
  },
  avatarCard: {
    minWidth: 160,
    maxWidth: 160,
    border: "2px solid #000",
    transition: "0.2s",
    boxShadow: "4px 4px 0px 0px rgba(0,0,0,1)",
    backgroundColor: "#fff !important",
    color: "#000 !important",
    position: "relative",
    "&:hover": {
      transform: "translate(-2px, -2px)",
      boxShadow: "6px 6px 0px 0px rgba(0,0,0,1)",
    }
  },
  selectedCard: {
    border: "2px solid #ccff00 !important",
    backgroundColor: "#fbffeb !important",
    boxShadow: "4px 4px 0px 0px #ccff00 !important",
  },
  checkIcon: {
    position: "absolute",
    bottom: 8,
    right: 8,
    color: "#ccff00",
    backgroundColor: "#000",
    borderRadius: "50%",
    border: "2px solid #000"
  },
  uploadBox: {
    border: "2px dashed #000",
    borderRadius: 0,
    padding: theme.spacing(4),
    textAlign: "center",
    cursor: "pointer",
    backgroundColor: "#fff",
    color: "#000",
    transition: "0.2s",
    boxShadow: "4px 4px 0px 0px rgba(0,0,0,1)",
    "&:hover": {
      backgroundColor: "#fbffeb",
      borderColor: "#ccff00",
      boxShadow: "4px 4px 0px 0px #ccff00",
      transform: "translate(-2px, -2px)",
    }
  },
  previewImg: {
    width: "100%",
    maxHeight: 200,
    objectFit: "contain",
    marginTop: theme.spacing(2),
    border: "2px solid #000"
  }
}));

const stockAvatars = [
  { id: "stock_1", name: "Emprendedora", img: "https://i.pravatar.cc/300?img=5" },
  { id: "stock_2", name: "Presentador", img: "https://i.pravatar.cc/300?img=8" },
  { id: "stock_3", name: "Doctora", img: "https://i.pravatar.cc/300?img=44" },
  { id: "stock_4", name: "UGC Casual", img: "https://i.pravatar.cc/300?img=12" },
  { id: "stock_5", name: "Ejecutivo Senior", img: "https://i.pravatar.cc/300?img=14" },
  { id: "stock_6", name: "Fitness Coach", img: "https://i.pravatar.cc/300?img=16" },
  { id: "stock_7", name: "Estudiante", img: "https://i.pravatar.cc/300?img=20" },
  { id: "stock_8", name: "Experta en Tech", img: "https://i.pravatar.cc/300?img=26" },
  { id: "stock_9", name: "Agente de Ventas", img: "https://i.pravatar.cc/300?img=68" },
  { id: "stock_10", name: "Nutricionista", img: "https://i.pravatar.cc/300?img=47" },
  { id: "stock_11", name: "Diseñadora", img: "https://i.pravatar.cc/300?img=45" },
  { id: "stock_12", name: "Asesor", img: "https://i.pravatar.cc/300?img=59" },
  { id: "stock_13", name: "Arquitecto", img: "https://i.pravatar.cc/300?img=60" },
  { id: "stock_14", name: "Abogada", img: "https://i.pravatar.cc/300?img=49" },
  { id: "stock_15", name: "Ingeniero", img: "https://i.pravatar.cc/300?img=61" },
  { id: "stock_16", name: "Periodista", img: "https://i.pravatar.cc/300?img=10" },
];

const StepAvatar = ({ formData, updateFormData }) => {
  const classes = useStyles();
  const avatarInputRef = useRef(null);
  const logoInputRef = useRef(null);

  const handleAvatarFile = (e) => {
    const file = e.target.files[0];
    if (file) {
      updateFormData("avatarFile", file);
      updateFormData("avatarId", null); // Override stock
    }
  };

  const handleLogoFile = (e) => {
    const file = e.target.files[0];
    if (file) {
      updateFormData("logoFile", file);
    }
  };

  return (
    <div>
      <Grid container spacing={4} className={classes.section}>
        {/* Columna Izquierda: Zonas de Subida */}
        <Grid item xs={12} md={4} lg={3}>
          <div style={{ position: "sticky", top: 0 }}>
            <Typography variant="h6" gutterBottom>
              1. Tu Personaje (Opcional)
            </Typography>
            <Typography variant="body2" color="textSecondary" style={{ marginBottom: 16 }}>
              Sube tu propia foto (JPG/PNG).
            </Typography>
            <div 
              className={classes.uploadBox} 
              onClick={() => avatarInputRef.current && avatarInputRef.current.click()}
              style={{ padding: 16 }}
            >
              <input 
                type="file" 
                accept="image/jpeg, image/png" 
                hidden 
                ref={avatarInputRef} 
                onChange={handleAvatarFile} 
              />
              <CloudUploadIcon color="primary" style={{ fontSize: 32 }} />
              <Typography variant="subtitle2" style={{ fontWeight: "bold" }}>
                Subir Foto
              </Typography>
              {formData.avatarFile && (
                <img 
                  src={URL.createObjectURL(formData.avatarFile)} 
                  alt="Avatar Preview" 
                  className={classes.previewImg} 
                />
              )}
            </div>

            <Typography variant="h6" gutterBottom style={{ marginTop: 32 }}>
              2. Marca de Agua (Opcional)
            </Typography>
            <Typography variant="body2" color="textSecondary" style={{ marginBottom: 16 }}>
              Logo de tu empresa en PNG.
            </Typography>
            <div 
              className={classes.uploadBox} 
              onClick={() => logoInputRef.current && logoInputRef.current.click()}
              style={{ padding: 16 }}
            >
              <input 
                type="file" 
                accept="image/png" 
                hidden 
                ref={logoInputRef} 
                onChange={handleLogoFile} 
              />
              <CloudUploadIcon color="primary" style={{ fontSize: 32 }} />
              <Typography variant="subtitle2" style={{ fontWeight: "bold" }}>
                Subir Logo
              </Typography>
              {formData.logoFile && (
                <img 
                  src={URL.createObjectURL(formData.logoFile)} 
                  alt="Logo Preview" 
                  className={classes.previewImg} 
                />
              )}
            </div>
          </div>
        </Grid>
        
        {/* Columna Derecha: Catálogo de Stock */}
        <Grid item xs={12} md={8} lg={9}>
          <Typography variant="h6" gutterBottom>
            O selecciona un modelo del catálogo (Stock):
          </Typography>
          <Grid container spacing={2}>
            {stockAvatars.map(av => {
              const isSelected = formData.avatarId === av.id && !formData.avatarFile;
              return (
                <Grid item xs={6} sm={4} md={3} key={av.id}>
                  <Card 
                    className={`${classes.avatarCard} ${isSelected ? classes.selectedCard : ""}`}
                    onClick={() => updateFormData("avatarId", av.id)}
                    style={{ minWidth: 'auto', maxWidth: '100%' }} // Override for grid fluid width
                  >
                    <CardActionArea>
                      <CardMedia component="img" image={av.img} alt={av.name} style={{ aspectRatio: '1/1', objectFit: 'cover', width: '100%' }} />
                      {isSelected && <CheckCircleIcon className={classes.checkIcon} />}
                      <Typography variant="caption" display="block" align="center" style={{ padding: "8px 4px", fontWeight: "bold" }}>
                        {av.name}
                      </Typography>
                    </CardActionArea>
                  </Card>
                </Grid>
              );
            })}
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default StepAvatar;
